import React from "react";
import "./Qidiruv.css";
import { FaSearch } from "react-icons/fa";

function Qidiruv({ onSearch, searchTerm }) {
  return (
    <div className="qidiruv-quti">
      <div className="qidiruv-sarlavha">
        <p>Kurslarni tanlang</p>
      </div>
      <div className="qidiruv-input">
        <form id="qidiruv-form" onSubmit={(e) => e.preventDefault()}>
          <input
            type="text"
            placeholder="Qidiruv"
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
          />
          <button type="submit">
            <FaSearch />
          </button>
        </form>
      </div>
    </div>
  );
}
export default Qidiruv;
